<template>
  <div id="Edition_details">
    <el-breadcrumb
      separator-class="el-icon-arrow-right"
      style="margin:100px 0 0 50px"
    >
      <el-breadcrumb-item :to="{ path: '/Home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>游戏列表</el-breadcrumb-item>
    </el-breadcrumb>
    <h3>
      <p>游戏列表</p>
      <span>游戏列表</span>
    </h3>
    <div class="toupdate">
      <div class="toupdatetop">
        <p class="fl">2019.{{ months }}</p>
        <div class="month">
          <a
            class="fl"
            v-for="(i, index) in monthlist"
            :key="index"
            @click="month(i, index)"
            :class="[index == monthflag ? 'monthcol' : 'monthcolm']"
          >
            {{ i.month }}月
          </a>
        </div>
      </div>
      <div class="toupdatecont">
        <!-- 游戏列表 -->
        <p style="font-size:20px;font-weight:bold">游戏列表</p>
        <ul>
          <li v-for="(i, index) in gamelist" :key="index">
            <div class="bigdiv">
              <div class="img fl">
                <img
                  draggable="false"
                  :src="i.image_url"
                  :alt="i.version_number"
                />
              </div>
              <div class="fl littlediv">
                <p>
                  <i>{{ i.download_url }}</i
                  >{{ i.version_number }}
                </p>
                <span>{{ i.version_desc }}</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
 metaInfo: {
    title:'海星云游戏列表，云电脑_云游戏平台_畅玩3A游戏大作-海星云官网',
    meta: [
      {
        name: 'keywords',
        content:'海星云电脑,云游戏,云游戏平台,云游戏免下载,云平台,海星云,云游戏主机,手机玩端游,免费加速器'
      },
      {
        name: 'description',
        content:'海星云无需升级电脑，即可享2080ti, 4K超高画质，低延迟的云游戏体验，支持手机 、平板、PC、TV等全平台畅玩，提供免费加速器，300+款3A大作，无需下载，即点即玩'
      }
    ]
  },
  data () {
    return {
      monthflag: 2,
      months: '8',
      monthlist: '',
      gamelist: ''
    }
  },
  methods: {
    month (i, index) {
      this.banben(i.month)
      this.months = i.month
      this.monthflag = index
    },
    banben (month) {
      this.http.chabb().then(res => {
        // console.log(res)
        // console.log(res.data.data.all_version,666)
        this.monthlist = res.data.data.all_version
        var a = res.data.data.all_version
        for (var i = 0; i < a.length; i++) {
          // console.log(res.data.data.all_version[i].month)
          if (res.data.data.all_version[i].month == month) {
            // console.log(res.data.data.all_version[i].version_type)
            var b = res.data.data.all_version[i].version_type
            for (var j = 0; j < b.length; j++) {
              // console.log(res.data.data.all_version[i].version_type[j],111)
              var c = res.data.data.all_version[i].version_type[j]
              // console.log(res.data.data.all_version[i].version_type[j].type,222)
              if (c.type == 10) {
                this.gamelist = c.version
                // console.log(this.gamelist,123456)
              }
            }
          }
        }
      })
    }
  },
  mounted () {
    var date = new Date()
    var montha = date.getMonth() + 1
    this.banben(8)
  }
}
</script>
<style scoped>
#Edition_details {
  width: 1200px;
  margin: 0 auto;
}
#Edition_details > h3 p {
  font-size: 30px;
  font-weight: bold;
  text-align: center;
  padding-top: 40px;
  margin-bottom: 10px;
}
#Edition_details > h3 span {
  display: block;
  font-size: 12px;
  color: #295ca4;
  text-align: center;
  padding-bottom: 42px;
}
.toupdate {
  width: 1120px;
  padding: 0 40px;
  margin: 0 auto;
}
.toupdate .toupdatetop {
  height: 60px;
  border-bottom: 1px solid #dfdfdf;
  overflow: hidden;
}
.toupdate .toupdatetop > p {
  font-size: 45px;
  font-weight: 500;
  color: #737373;
  margin-right: 30px;
}
.toupdate .toupdatetop .month {
  overflow: hidden;
  margin-top: 15px;
}
.toupdate .toupdatetop .month a {
  display: block;
  margin-right: 3px;
  width: 42px;
  padding: 0 14px;
  line-height: 30px;
  /* background: #f2f2f2;
    color: #737373; */
  text-align: center;
}
.toupdate .toupdatetop .month a:hover {
  background: #737373;
  color: #f2f2f2;
}
.toupdate .toupdatecont {
  padding-left: 60px;
}
.toupdate .toupdatecont ul {
  border-left: 2px solid #dfdfdf;
  padding-left: 120px;
}
.toupdate .toupdatecont ul li {
  height: 137px;
  padding: 42px 0;
  border-bottom: 1px dotted #dfdfdf;
  padding-right: 20px;
}
.toupdate .toupdatecont ul li .bigdiv {
  padding: 10px 0;
  overflow: hidden;
  /* transition: background 0.5s; */
  transition: all 1s;
}
.toupdate .toupdatecont ul li .bigdiv:hover {
  background: #f7f7f7;
}
.toupdate .toupdatecont ul li .bigdiv:hover img {
  transform: scale(1.2);
}
.toupdate .toupdatecont ul li .bigdiv .img {
  width: 208px;
  height: 117px;
  margin-right: 20px;
  overflow: hidden;
}
.toupdate .toupdatecont ul li .bigdiv .img img {
  width: 208px;
  height: 117px;
  transition: all 0.5s;
}
.toupdate .toupdatecont ul li .littlediv {
  width: 43.125rem;
  height: 100%;
}
.toupdate .toupdatecont ul li .littlediv p {
  display: block;
  width: 100%;
  font-size: 10px;
  font-weight: bold;
  line-height: 20px;
  color: #737373;
  background-color: #f7f7f7;
  margin-bottom: 5px;
}
.toupdate .toupdatecont ul li .littlediv p i {
  /* width: 104px; */
  padding: 0 5px;
  height: 20px;
  background: #295ca4;
  color: #fff;
  margin-right: 8px;
}
.toupdate .toupdatecont ul li .littlediv span {
  font-size: 16px;
  font-weight: bold;
}
.monthcol {
  background: #295ca4;
  color: #fff;
}
.monthcolm {
  background: #f2f2f2;
}
</style>



// WEBPACK FOOTER //
// src/components/game_details.vue